export const heroMedia = {
    heroBackground: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779102577/new_design/beae5847fa42de7d7f02fb260c071eec3d23f5fa_vqp5t6.webp",
    heroBackgroundMobile: "https://res.cloudinary.com/dirscuuhp/image/upload/v1779704403/new_design/Hero_krj56w.webp",
    founderVideo: "https://res.cloudinary.com/dirscuuhp/video/upload/v1779264908/new_design/sarah_blackandwhite_desktop_xtuykz.mp4",
    founderVideoPoster: "https://res.cloudinary.com/dirscuuhp/video/upload/so_0,f_webp,q_auto/v1779264908/new_design/sarah_blackandwhite_desktop_xtuykz.webp",
    founderVideoMobile: "https://res.cloudinary.com/dirscuuhp/video/upload/v1779704689/new_design/sarah_blackandwhite_mobile_1_i8zetx.mp4",
    founderVideoMobilePoster: "https://res.cloudinary.com/dirscuuhp/video/upload/so_0,f_webp,q_auto/v1779704689/new_design/sarah_blackandwhite_mobile_1_i8zetx.webp",
    founderSignature: "https://res.cloudinary.com/dirscuuhp/image/upload/v1777561530/new_design/signature-white_tj2oaj.webp",
    missionPhone: "https://res.cloudinary.com/dirscuuhp/image/upload/v1780522237/new_design/iPhone_13_Pro_-_Right_tsg3qo.webp",
};

export const heroPills = [
    {
        text: "Why am I so anxious?",
        className: "max-md:hidden absolute top-[77%] md:top-[49%] left-[6%] md:left-[21%]",
    },
    {
        text: "I'm exhausted no matter how much I sleep.",
        className: "max-md:hidden absolute top-[56%] right-[9%]",
    },
    {
        text: "My periods are heavier and unpredictable!",
        className: "max-md:hidden absolute top-[66%] left-[14%]",
    },
    {
        text: "My brain fog just won't lift.",
        className: "max-md:hidden absolute top-[88%] md:top-[69%] right-[5%] md:right-[21%]",
    },
];
